// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* nav {
    background-color: #ffffff;
} */
/* .pagination li a
{
    color: #e31837;
    border: 1px solid #e31837;
}
.pagination li a:hover{
    background-color: #e31837;
    color: #ffffff;
} */`, "",{"version":3,"sources":["webpack://./src/constant/pagination.css"],"names":[],"mappings":"AAAA;;GAEG;AACH;;;;;;;;GAQG","sourcesContent":["/* nav {\n    background-color: #ffffff;\n} */\n/* .pagination li a\n{\n    color: #e31837;\n    border: 1px solid #e31837;\n}\n.pagination li a:hover{\n    background-color: #e31837;\n    color: #ffffff;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
